import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useFirebaseEvent } from 'hooks'
import { FIREBASE_EVENTS } from 'app-constants'
import { Button } from 'components'
import { STATICS } from 'statics'
import { sendWhatsappMessage } from 'utils'
import './style.scss'

export function IntegrationError() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  useEffect(() => {
    sendEvent(FIREBASE_EVENTS.SVA_ACTIVATION_INTEGRATION_ERROR)
  }, [sendEvent])

  function handleTalkAttendantClick() {
    sendEvent(FIREBASE_EVENTS.SVA_ACTIVATION_INTEGRATION_ERROR_TALK_WITH_ATTENDANT)
    dispatch(sendWhatsappMessage)
  }

  return (
    <div className='container-integration-error'>
      <div className='container-info'>
        <div className='container-icon'>
          <STATICS.INFO_ERROR />
        </div>
        <span className='title'>Ops! Houve uma falha na ativação do seu serviço.</span>
        <span className='description'>
          Para continuar, clique abaixo no botão &apos; Falar com o atendimento&apos; e siga o
          caminho:
        </span>
        <span className='path'>
          Suporte &gt; Streaming &gt; Escolha &quot; Qual produto quer falar &quot; &gt; Falar com
          especialista.
        </span>
      </div>
      <div className='container-buttons'>
        <Button onClick={handleTalkAttendantClick} className='button accept' color='primary'>
          Falar com o atendimento
        </Button>
      </div>
    </div>
  )
}
